var UserGameSummary = React.createClass({
  propTypes: {
    gameData: React.PropTypes.object.isRequired
  },
  getInitialState() {
    return {
      modalVisible: false,
      gameEvents: [],
      progressWidth: 0
    }
  },
  componentDidMount() {
    let game = this.props.gameData;
    if (!game.nextLevel) return;

    let progress = ((game.totalPoints / game.nextLevel.minPoints) * 100).toPrecision(3);

    setTimeout(() => {
      this.setState({progressWidth: progress});
    }, 250);
  },
  getLevelDescription(level) {
    if (isNaN(level.description)) {
      return level.description
    } else {
      return `${Labels.getLabel("Level")} ${level.description}`;
    }
  },
  showGameDetail() {
    if (this.state.gameEvents.length == 0) {
      let url = `${Config.contextPath}/controller/report/gamification/getAllEventsForUser`;
      $.get(url)
        .done(r => this.setState({gameEvents: r.events, modalVisible: true}));
    } else {
      this.setState({modalVisible: true});
    }
  },
  hideModal() {
    this.setState({modalVisible: false});
  },
  formatNumber(val) {
    return Number.prototype.toLocaleString ? val.toLocaleString() : val;
  },
  renderProgress() {
    let game = this.props.gameData;
    let {progressWidth} = this.state;

    if (!game.nextLevel) return;

    return (
      <div>
        <span className="pull-right">{this.formatNumber(game.nextLevel.minPoints)}</span>
        <span>{Labels.getLabel("Next Level")}</span>

        <div className="progress game-summary__progress">
          <div
            className="progress-bar"
            role="progressbar"
            aria-valuenow={progressWidth}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{width: (progressWidth<100?progressWidth:100) + "%"}}>
          </div>
        </div>
      </div>
    )
  },
  render() {
    let game = this.props.gameData;

    return (
      <div>
        <div className="game-summary">
          <div className="game-summary__icon">
            <span className="fa fa-trophy" role="presentation"></span>
          </div>

          <h3 className="game-summary__title">
            {Labels.getLabel("My Score")}
          </h3>

          <div className="game-summary__detail">
            <ChildDelimited
              delimiter={<span className="dot" role="presentation"></span>}>
              <strong>{this.getLevelDescription(game.level)}</strong>
              <span>{this.formatNumber(game.totalPoints)} {Labels.getLabel("points")}</span>
            </ChildDelimited>

            <a href="#"
              className="game-summary__help-link"
              role="button"
              onClick={this.showGameDetail}>
              {Labels.getLabel("How do I get points?")}
            </a>
          </div>

          {this.renderProgress()}
        </div>

        <Modal
          show={this.state.modalVisible}
          onHide={this.hideModal}>
          <Modal.Header closeButton>
            <Modal.Title>{Labels.getLabel("How do I get points?")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{Labels.getLabel("Event")}</th>
                  <th className="text-right">{Labels.getLabel("Points")}</th>
                </tr>
              </thead>
              <tbody>
                {this.state.gameEvents.map((data, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{data.description}</td>
                      <td className="text-right">{data.points}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-default" onClick={this.hideModal}>{Labels.getLabel("Close")}</button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
})